import { Col, Image, Row, Tooltip } from "antd";

import { useEffect, useMemo, useState } from "react";
import AnalyticsCard from "../analyticsCard";
import { TotalSalesIcon } from "../../assets/reportPageIcon";
import CustomTable from "../table/index";
import { useCurrency } from "../../provider/courtryProvider";
import config from "../../config";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Alert } from "react-bootstrap";
import { GiExpense, GiProfit } from "react-icons/gi";
import { CiDiscount1 } from "react-icons/ci";
import { HiReceiptTax } from "react-icons/hi";
import LossIcon from "../../assets/images/tax.svg";
import { InfoCircleFilled } from "@ant-design/icons";

const ProfitAndLoss = ({
  billList = [],
  date = {},
  isLoading = false,
  onSetExportBillLevel = () => {},
  onSetExportProfitLoss = () => {},
  selectedEmployee = "",
}) => {
  const [profitAnalysis, setProfitAnalysis] = useState({
    profit: 0,
    loss: 0,
    discount: 0,
    tax: 0,
  });
  const [expensesList, setExpensesList] = useState([]);
  const currencyFormatter = useCurrency();
  const expenseTypeList = useSelector(
    (state) => state.shopDetails.expensesType
  );
  const shopDetails = useSelector((state) => state.shopDetails);

  const itemLevelSales = useMemo(() => {
    const products = {};
    billList.forEach((i) =>
      i.items.forEach((item) => {
        if (products.hasOwnProperty(item.productId)) {
          if (!item.fullyReturned) {
            products[item.productId] = [...products[item.productId], item];
          }
        } else {
          if (!item.fullyReturned) {
            products[item.productId] = [item];
          }
        }
      })
    );
    const averageProductsKeys = Object.keys(products);
    const averageProducts = averageProductsKeys.map((key) => {
      const totalQuantity = products[key].reduce(
        (a, b) => a + (parseFloat(b.count) - parseFloat(b.returned || 0)),
        0
      );
      const totalProductPrice = products[key].reduce(
        (a, b) =>
          a +
          parseFloat(b.productPrice) *
            (parseFloat(b.count) - parseFloat(b.returned || 0)),
        0
      );
      const totalPurchasePrice = products[key].reduce((a, b) => {
        const purchasePrice = b.parentProductId
          ? parseFloat(b.purchaseRate || 0)
            ? parseFloat(b.purchaseRate || 0)
            : parseFloat(b.purchasePrice || 0) *
              (parseFloat(b.count) - parseFloat(b.returned || 0))
          : parseFloat(b.purchaseRate || 0)
          ? parseFloat(b.purchaseRate || 0)
          : parseFloat(b.purchasePrice || 0) *
            (parseFloat(b.count) - parseFloat(b.returned || 0));
        return a + purchasePrice;
      }, 0);
      let discountAmount = 0;
      let taxAmount = 0;
      products[key].forEach((item) => {
        let tax = 0;
        if (!item.fullyReturned) {
          if (parseFloat(item.count) !== parseFloat(item.returned)) {
            tax =
              parseFloat(item.gst || 0) +
              parseFloat(item.igst || 0) +
              parseFloat(item.cess || 0) +
              parseFloat(item.additionalcess || 0);
            const perQuantityTax = tax / parseFloat(item.count);
            tax =
              perQuantityTax *
              (parseFloat(item.count) - parseFloat(item.returned || 0));
          }

          if (item.discountPrice && item.discountType) {
            let discount = 0;
            if (item.taxIncExc !== "exclusive") {
              discount =
                parseFloat(item.productPrice) *
                  (parseFloat(item.count) - parseFloat(item.returned || 0)) -
                Math.round(parseFloat(item.itemTotal));
            } else if (item.taxIncExc === "exclusive") {
              discount =
                parseFloat(item.productPrice) *
                  (parseFloat(item.count) - parseFloat(item.returned || 0)) -
                Math.round(parseFloat(item.itemTotal) - tax);
            }
            discountAmount += discount;
          }
          console.log("taxAmount123", tax, products[key][0].productName, item);
          taxAmount += parseFloat(tax);
        }
      });
      const isFullyReturned = products[key].every(
        (i) => i.fullyReturned === true
      );
      if (isFullyReturned) {
        discountAmount = 0;
      }
      const profit = totalProductPrice - totalPurchasePrice - discountAmount;
      let loss = 0;
      if (profit < 0) {
        loss = profit;
      }
      let productName = products[key][0].productName;
      if (
        products[key][0].unitOfMeasurment !== "Others" &&
        !products[key][0].unitOfMeasurment !== true
      ) {
        productName += `(${products[key][0].unitOfMeasurment})`;
      }
      if (products[key][0].size) {
        productName += ` Size:${products[key][0].size}`;
      }

      console.log("productName12", productName);
      return {
        productId: key,
        color: products[key][0].color,
        productName: productName,
        averageProductPrice: parseFloat(
          totalProductPrice / (totalQuantity || 1)
        ).toFixed(2),
        averagePurchasePrice: parseFloat(
          totalPurchasePrice / (totalQuantity || 1)
        ).toFixed(2),
        totalProductPrice: totalProductPrice,
        totalQuantity: totalQuantity,
        totalPurchasePrice: totalPurchasePrice,
        discountAmount: discountAmount,
        taxAmount: parseFloat(taxAmount).toFixed(2),
        profit: profit < 0 ? 0 : parseFloat(profit).toFixed(2),
        loss: parseFloat(loss).toFixed(2),
      };
    });
    averageProducts.sort((a, b) => {
      if (a.productName < b.productName) {
        return -1;
      }
      if (a.productName > b.productName) {
        return 1;
      }
      return 0;
    });

    onSetExportProfitLoss(averageProducts);
    return averageProducts;
  }, [billList]);

  const billLevelSales = useMemo(() => {
    let totalDiscount = 0;
    let totalTax = 0;
    let totalProfit = 0;
    let totalLoss = 0;
    const billSales = billList.map((item) => {
      const totalPurchasePrice = item.items.reduce((a, b) => {
        const purchasePrice = b.parentProductId
          ? parseFloat(b.purchaseRate || 0) *
            (parseFloat(b.count) - parseFloat(b.returned || 0))
          : parseFloat(b.purchasePrice || 0) *
            (parseFloat(b.count) - parseFloat(b.returned || 0));
        return a + purchasePrice;
      }, 0);
      const totalProductPrice = item.items.reduce((a, b) => {
        return (
          a +
          parseFloat(b.productPrice || 0) *
            (parseFloat(b.count) - parseFloat(b.returned || 0))
        );
      }, 0);
      let taxInclusive = 0;
      let taxExclusive = 0;

      item.items.forEach((product) => {
        const taxUsed = product.taxType
          ? product.taxType
          : ["gst", "igst", "cess", "additionalcess"];
        const perQuantityTax =
          taxUsed.reduce((acc, curr) => {
            return acc + parseFloat(product[curr] || 0);
          }, 0) / parseFloat(product.count);

        if (product.taxIncExc === "exclusive") {
          taxExclusive +=
            perQuantityTax *
            (parseFloat(product.count) - parseFloat(product.returned || 0));
        } else if (product.taxIncExc === "inclusive") {
          taxInclusive +=
            perQuantityTax *
            (parseFloat(product.count) - parseFloat(product.returned || 0));
        }
      });

      const isFullyReturned = item.items.every((i) => i.fullyReturned === true);
      let isRemovedDiscount = false;
      if (item.billReturn) {
        isRemovedDiscount = item.billReturn.some(
          (i) => i.discount === "removed"
        );
      }
      let discountAmount = 0;
      item.items.forEach((product) => {
        if (product.discountPrice && product.discountType) {
          const taxUsed = product.taxType
            ? product.taxType
            : ["gst", "igst", "cess", "additionalcess"];
          const tax = taxUsed.reduce((acc, curr) => {
            return acc + parseFloat(product[curr] || 0);
          }, 0);
          let discount = 0;
          if (product.taxIncExc !== "exclusive") {
            discount =
              parseFloat(product.productPrice) *
                (parseFloat(product.count) -
                  parseFloat(product.returned || 0)) -
              Math.round(parseFloat(product.itemTotal));
          } else if (product.taxIncExc === "exclusive") {
            discount =
              parseFloat(product.productPrice) *
                (parseFloat(product.count) -
                  parseFloat(product.returned || 0)) -
              Math.round(parseFloat(product.itemTotal) - tax);
          }

          discountAmount += discount;
        }
      });

      let tax = taxInclusive + taxExclusive;

      const discountType = item.otherDetails
        ? item.otherDetails.discountType
        : item.discountType;
      const discountValue = item.otherDetails
        ? parseFloat(item.otherDetails.discount) || 0
        : parseFloat(item.discount) || 0;
      const productTotal = item.otherDetails
        ? item.otherDetails.productTotal
        : item.productTotal;
      if (discountType === "percentage") {
        discountAmount += (parseFloat(productTotal) * discountValue) / 100;
      } else if (discountType === "flat") {
        discountAmount += discountValue;
      }
      if (isFullyReturned || isRemovedDiscount) {
        discountAmount = 0;
      }
      let profit =
        totalProductPrice -
        totalPurchasePrice -
        discountAmount -
        parseFloat(taxInclusive);
      let loss = 0;
      if (profit < 0) {
        loss = profit;
      }

      if (item.loyaltyDiscount > 0) {
        profit = profit - parseFloat(item.loyaltyDiscount);
      }

      totalDiscount += discountAmount;
      totalTax += parseFloat(tax);
      totalLoss += loss;
      if (profit > 0) {
        totalProfit += profit;
      }
      if (item.roundOff) {
        totalProfit += parseFloat(item.roundOff);
        profit += parseFloat(item.roundOff);
      }

      return {
        ...item,
        subTotal: item.otherDetails
          ? item.otherDetails.productTotal
          : item.productTotal,
        totalPurchasePrice,
        totalProductPrice,
        loyaltyDiscount: parseFloat(item.loyaltyDiscount || 0),
        discountAmount: parseFloat(discountAmount).toFixed(2),
        taxAmount: parseFloat(tax).toFixed(2),
        profit: profit < 0 ? 0 : parseFloat(profit).toFixed(2),
        loss: parseFloat(loss).toFixed(2),
      };
    });
    billSales.sort((a, b) => {
      if (
        typeof a.invoiceNumber === "number" &&
        typeof b.invoiceNumber === "number"
      ) {
        return a.invoiceNumber - b.invoiceNumber;
      } else if (
        typeof a.invoiceNumber === "number" &&
        typeof b.invoiceNumber !== "number"
      ) {
        return -1;
      } else if (
        typeof a.invoiceNumber !== "number" &&
        typeof b.invoiceNumber === "number"
      ) {
        return 1;
      } else {
        return a.invoiceNumber > b.invoiceNumber ? 1 : -1;
      }
    });

    const totalSale = billList.reduce((a, b) => {
      const billSale = parseFloat(b.amountPaid);
      let returnedAmount = 0;
      if (b.billReturn) {
        returnedAmount = b.billReturn.reduce((a, b) => {
          return a + parseFloat(b.repayAmount);
        }, 0);
      }
      const billTotal = billSale - returnedAmount;
      return a + billTotal;
    }, 0);

    setProfitAnalysis({
      totalSale: totalSale,
      profit: totalProfit,
      loss: totalLoss,
      discount: totalDiscount,
      tax: totalTax,
    });

    onSetExportBillLevel(billSales);

    return billSales;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billList]);

  const columns = [
    {
      title: "Product Name",
      key: "productName",
      sorter: (a, b) => {
        if (a.productName < b.productName) {
          return -1;
        }
        if (a.productName > b.productName) {
          return 1;
        }
        return 0;
      },
      render: (rowData) => {
        return (
          <div>
            {rowData.productName}
            {rowData.color && (
              <span
                style={{
                  height: "20px",
                  width: "20px",
                  borderRadius: "50%",
                  backgroundColor: rowData.color,
                  display: "inline-block",
                  marginLeft: "0.5rem",
                  marginRight: "0.5rem",
                  verticalAlign: "middle",
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "Selling Price",
      dataIndex: "averageProductPrice",
      key: "averageProductPrice",
      sorter: (a, b) => {
        return a.averageProductPrice - b.averageProductPrice;
      },
    },
    {
      title: "Purchase Price",
      dataIndex: "averagePurchasePrice",
      key: "averagePurchasePrice",
      sorter: (a, b) => {
        return a.averagePurchasePrice - b.averagePurchasePrice;
      },
    },
    {
      title: "Quantity",
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      sorter: (a, b) => {
        return a.totalQuantity - b.totalQuantity;
      },
    },
    {
      title: "Discount",
      dataIndex: "discountAmount",
      key: "discountAmount",
      sorter: (a, b) => {
        return a.discountAmount - b.discountAmount;
      },
    },
    {
      title: "Tax",
      dataIndex: "taxAmount",
      key: "taxAmount",
      sorter: (a, b) => {
        return a.taxAmount - b.taxAmount;
      },
    },
    {
      title: "Profit",
      dataIndex: "profit",
      key: "profit",
      sorter: (a, b) => {
        return a.profit - b.profit;
      },
    },
    {
      title: "Loss",
      dataIndex: "loss",
      key: "loss",
      sorter: (a, b) => {
        return a.loss - b.loss;
      },
    },
  ];

  const columnsBillLevel = [
    {
      title: "Invoice Number",
      key: "invoicePrefix",
      render: (rowData) => {
        return <div>{rowData.invoicePrefix + " " + rowData.invoiceNumber}</div>;
      },
      sorter: (a, b) => {
        if (
          typeof a.invoiceNumber === "number" &&
          typeof b.invoiceNumber === "number"
        ) {
          return a.invoiceNumber - b.invoiceNumber;
        } else if (
          typeof a.invoiceNumber === "number" &&
          typeof b.invoiceNumber !== "number"
        ) {
          return -1;
        } else if (
          typeof a.invoiceNumber !== "number" &&
          typeof b.invoiceNumber === "number"
        ) {
          return 1;
        } else {
          return a.invoiceNumber > b.invoiceNumber ? 1 : -1;
        }
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      sorter: (a, b) => {
        return a.customerName.localeCompare(b.customerName);
      },
    },
    {
      title: "Customer Phone Number",
      dataIndex: "customerPhoneNumber",
      key: "customerPhoneNumber",
    },
    {
      title: "Bill Amount",
      dataIndex: "amountPaid",
      key: "amountPaid",
      sorter: (a, b) => {
        return a.amountPaid - b.amountPaid;
      },
    },
    {
      title: (
        <span>
          Sub Total{" "}
          <Tooltip
            title={
              "This subtotal is before applying discount and other charges"
            }
          >
            <InfoCircleFilled />
          </Tooltip>{" "}
        </span>
      ),
      key: "subTotal",
      render: (rowData) => {
        return <div>{rowData?.subTotal?.toFixed(2)}</div>;
      },

      showSorterTooltip: false,
      sorter: (a, b) => {
        return a.subTotal - b.subTotal;
      },
    },
    {
      title: "Loyalty Discount",
      key: "loyaltyDiscount",
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.loyaltyDiscount)}</div>;
      },
      sorter: (a, b) => {
        return a.loyaltyDiscount - b.loyaltyDiscount;
      },
    },
    {
      title: "Discount",
      key: "discountAmount",
      dataIndex: "discountAmount",
      sorter: (a, b) => {
        return a.discountAmount - b.discountAmount;
      },
    },
    {
      title: "Tax",
      key: "Tax",
      sorter: (a, b) => {
        return a.taxAmount - b.taxAmount;
      },
      render: (rowData) => {
        return <div>{rowData.taxAmount}</div>;
      },
    },
    {
      title: "Profit",
      dataIndex: "profit",
      key: "profit",
      sorter: (a, b) => {
        return a.profit - b.profit;
      },
    },
    {
      title: "Loss",
      dataIndex: "loss",
      key: "loss",
      sorter: (a, b) => {
        return a.loss - b.loss;
      },
    },
  ];

  const fetchExpenses = async () => {
    try {
      let res = await fetch(`${config.newApiGateway}/expenses/expenses`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "x-api-key": `${config.newApiKey}`,
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopDetails.shopId,
          from: dayjs(date[0]).format("YYYY-MM-DD"),
          to: dayjs(date[1]).format("YYYY-MM-DD"),
          employeeId: shopDetails.empId ? shopDetails.empId : "",
        }),
      });
      res = await res.json();

      if (res.code === "SUCCESS") {
        const result = res.data.map((i) => {
          const type = expenseTypeList.find(
            (item) => item.expensesTypeId === i.expenseType
          );
          return {
            ...i,
            expenseTypeName: type ? type.expensesTypeName : "",
          };
        });
        setExpensesList(result);
      }
    } catch (err) {
      console.error("Error", err);
    } finally {
    }
  };

  const totalExpenses = useMemo(() => {
    if (selectedEmployee) {
      return expensesList
        .filter((i) => i.employeeId === selectedEmployee)
        .reduce((a, c) => a + parseFloat(c.expenseAmount), 0);
    } else {
      return expensesList.reduce((a, c) => a + parseFloat(c.expenseAmount), 0);
    }
  }, [expensesList, selectedEmployee]);

  useEffect(() => {
    if (shopDetails.shopId) {
      fetchExpenses(date);
    }
  }, [shopDetails.shopId, date]);

  const exportHeadProductLevel = [
    "Product Name",
    "Selling Price",
    "Purchase Price",
    "Quantity",
    "Discount",
    "Tax",
    "Profit",
    "Loss",
  ];

  const exportValueProductLevel = [
    "productName",
    "averageProductPrice",
    "averagePurchasePrice",
    "totalQuantity",
    "discountAmount",
    "taxAmount",
    "profit",
    "loss",
  ];

  const exportHeadBillLevel = [
    "Invoice Number",
    "Customer Name",
    "Customer Phone Number	",
    "Bill Amount",
    "Discount",
    "Tax",
    "Profit",
    "Loss",
  ];

  const exportValueBillLevel = [
    {
      field: "invoiceNumber",
      render: (rowData) => {
        return rowData.invoicePrefix + " " + rowData.invoiceNumber;
      },
    },
    "customerName",
    "customerPhoneNumber",
    "amountPaid",
    "discountAmount",
    "Tax",
    "profit",
    "loss",
  ];

  return (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Alert
        style={{
          textAlign: "center",
          fontSize: 12,
          padding: 4,
        }}
        variant="danger"
      >
        If a product doesn't have purchase price, we'll assume it as 100% profit
      </Alert>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(profitAnalysis.totalSale)}
            value={"Total Sales"}
            icon={<TotalSalesIcon size={35} color={"#fff"} />}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(totalExpenses)}
            value={"Total Expenses"}
            icon={<GiExpense size={35} color={"#fff"} />}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(profitAnalysis.discount)}
            value={"Gross Discount"}
            icon={<CiDiscount1 size={35} color={"#fff"} />}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(profitAnalysis.tax)}
            value={"Gross Tax"}
            icon={<HiReceiptTax size={35} color={"#fff"} />}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(profitAnalysis.profit)}
            value={"Total Profit"}
            icon={<GiProfit size={35} color={"#fff"} />}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
          <AnalyticsCard
            label={currencyFormatter(profitAnalysis.loss)}
            value={"Total Loss"}
            icon={
              <Image
                src={LossIcon}
                style={{
                  width: 35,
                  height: 35,
                }}
              />
            }
          />
        </Col>
      </Row>

      <CustomTable
        title={"Product Level Sales"}
        excelExport={true}
        exportHead={exportHeadProductLevel}
        exportValue={exportValueProductLevel}
        columns={columns}
        data={itemLevelSales}
      />
      <div style={{ marginTop: 20 }} />
      <CustomTable
        title={"Bill Level Sales"}
        columns={columnsBillLevel}
        excelExport={true}
        exportHead={exportHeadBillLevel}
        exportValue={exportValueBillLevel}
        data={billLevelSales}
      />
    </div>
  );
};

export default ProfitAndLoss;
